import { render, staticRenderFns } from "./purchases-data.vue?vue&type=template&id=da2c4508&"
import script from "./purchases-data.vue?vue&type=script&lang=js&"
export * from "./purchases-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports